import { resolveFundParseDate } from "./fundParseDateUtils";
import { FundParseFormValues, getInitialFundParseFormValues } from "./fundParseDefaults";
import { withClientIdInPositionClientIds } from "./fundParseUtils";

export function getDefaultFundParseUrlDate(): string {
    return resolveFundParseDate("previousmonth");
}

export function buildFundParsePath(clientId: string, date?: string): string {
    let pathDate = getDefaultFundParseUrlDate();
    if (date) {
        try {
            pathDate = resolveFundParseDate(date);
        } catch {
            pathDate = getDefaultFundParseUrlDate();
        }
    }
    return `/fundparse/${clientId}/${pathDate}`;
}

export function getFundParseFormValuesFromRoute(clientId?: string, routeDate?: string): FundParseFormValues {
    const values = getInitialFundParseFormValues();
    if (clientId) {
        values.client_id = clientId;
        values.position_client_ids = withClientIdInPositionClientIds(clientId, []);
    }
    if (routeDate) {
        values.date = routeDate;
    }
    return values;
}
